import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'loyal-react'

const Profile = ({
  profile: { name }
}) => (
  <li className='px-1 h-auto border-color-ui-3 border-bottom bg-brand-2'>
    <div className='row align-items-center h-100 pos-relative'>
      <button
        className='btn btn-sm btn-double btn-flat btn-icon txt-font-body txt-initial txt-body txt-left py-1 default'
        role='button'
        tabIndex='-1'
      >
        <Icon iconName='icon_profile color-ui-white' />
        <p className='txt-body-sm color-ui-white py-1 pl-3'>
          Olá, {formatName(name)}!
        </p>
      </button>
    </div>
  </li>
)

const formatName = name => {
  return name.split(' ')[0]
}

Profile.propTypes = {
  profile: PropTypes.object
}

export default Profile



// WEBPACK FOOTER //
// ./src/App/MainMenu/MenuMobile/Profile/Profile.js